const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/privacy-policy",
    component: "PrivacyPolicy",
    exact: true,
  },
  {
    path: "/terms-and-conditions",
    component: "TermsAndConditions",
    exact: true,
  },
];

export default routes;
